import { Context } from "../Engine";
import { PropertyAnimation } from "../../Common/Animation/PropertyAnimation";

export class ObjectManager {

    private allObjects: Set<IDrawableObject>;
    private sortedObjects: ObjectModeList;

    constructor() {
        this.allObjects = new Set<IDrawableObject>();
        this.sortedObjects = {};
    }

    public addObject(obj: IDrawableObject): void {
        if (this.allObjects.has(obj)) {
            return;
        }

        this.allObjects.add(obj);

        for (let mode of obj.getModes()) {

            if (!this.sortedObjects[mode]) {
                this.sortedObjects[mode] = [];
            }
            // TODO: Refactor object into an array, object key order is not guaranteed and may cause weird render bugs between browsers
            let modeList = this.sortedObjects[mode];

            let shaderReference = obj.getShaderReference(mode);

            let found = false;
            for (let m of modeList) {
                if (m.shaderReference === shaderReference) {
                    m.objects.push(obj);
                    found = true;

                    m.objects = m.objects.sort((a: any, b: any) => {
                        if (a.texture && !b.texture) {
                            return 1;
                        } else if (!a.texture && b.texture) {
                            return -1;
                        } else if (a.texture && b.texture) {
                            if(a.texture.translucent && b.texture.translucent) {
                                return 0;
                            }else {
                                if(a.texture.translucent) {
                                    return 1;
                                }else {
                                    return -1;
                                }
                            }
                        } else {
                            return 0;
                        }
                    });

                    break;
                }
            }
            if (!found) {
                modeList.push({
                    shaderReference: shaderReference,
                    objects: [obj]
                });
            }

        }
    }

    public removeObject(obj: IDrawableObject) {

        if (!this.allObjects.has(obj)) {
            console.log('cant remove')
            return;
        }

        this.allObjects.delete(obj);

        for (let mode of obj.getModes()) {
            let modeList = this.sortedObjects[mode];

            if (!modeList) {
                continue;
            }

            for (let m of modeList) {
                let index = m.objects.indexOf(obj);
                if (index !== -1) {
                    m.objects.splice(index, 1);
                }

            }
        }

    }

    // Iterate will iterate over the objects that should be rendered in a way that is considered efficient in terms
    // of WebGL rendering, i.e., it sorts objects by shader and texture so switching shaders and textures is kept to 
    // a minimum.
    // TODO: Currently only sorts by shader, add textures too?
    public iterate(mode: string, callback: (obj: IDrawableObject) => void) {

        let modeList = this.sortedObjects[mode];
        if (!modeList) return;

        for (let list of modeList) {

            for (let obj of list.objects) {
                callback(obj);
            }
        }
    }
}

type ObjectModeList = {
    [key: string]: {
        shaderReference: string,
        objects: IDrawableObject[]
    }[]
}

export interface IDrawableObject {
    draw(ctx: Context, picking: boolean): void;
    getModes(): string[];
    getShaderReference(mode: string): string;
    animatedProperties: PropertyAnimation;
    interaction: ObjectInteraction;
}

export class CompositeObjectInteraction implements ObjectInteraction {

    private interactors: Set<ObjectInteraction>;

    constructor() {
        this.interactors = new Set<ObjectInteraction>();
    }

    public addInteractor(interactor: ObjectInteraction) {
        this.interactors.add(interactor);
    }

    public removeInteractor(interactor: ObjectInteraction) {
        this.interactors.delete(interactor);
    }

    public onPressDown() {
        this.invokeInteractor('onPressDown');
    }

    public onPressRelease() {
        this.invokeInteractor('onPressRelease');
    }

    public onHoverIn() {
        this.invokeInteractor('onHoverIn');
    }

    public onHoverOut() {
        this.invokeInteractor('onHoverOut');
    }

    private invokeInteractor(type: string) {
        this.interactors.forEach(interactor => {
            if (interactor[type]) {
                interactor[type]();
            }
        });
    }
}

export type ObjectInteraction = {
    onPressDown?: () => void,
    onPressRelease?: () => void,
    onHoverIn?: () => void,
    onHoverOut?: () => void
}